import CustomButton from 'components/customButton';
import React from 'react';
import EmptyImage from 'assets/images/noImage/background store 4.svg';
import useChooseWinner from 'modules/myAdvertisment/hooks/useChooseWinner';

interface ParticipatedCardProps {
  participated_auctions: number;
  name: string;
  image: string | null;
  guid: string;
  cardType: 'auction' | 'prepayment';
  is_saled: boolean;
  isDelete?: boolean;
  setIsOpenModal: (isOpen: boolean) => void;
}
const ParticipatedCard = ({
  guid,
  participated_auctions,
  name,
  image,
  cardType,
  isDelete,
  is_saled,
  setIsOpenModal,
}: ParticipatedCardProps) => {
  const {mutate} = useChooseWinner({cardType});
  return (
    <div className="bg-white w-[90%] flex flex-col rounded-lg p-4 gap-4 justify-center">
      <div className="flex flex-col w-[90%] gap-4 justify-center">
        <div className="flex items-center gap-4">
          <img
            className="w-[70px] h-[70px] rounded-full"
            src={image ? image : EmptyImage}
            alt={name}
          />
          <p className="text-gray-6 text-[16px] font-bold">{name}</p>
        </div>
        <div className="flex flex-col gap-4 text-black">
          <div className="flex w-full font-normal text-[16px] justify-between">
            <span>تعداد مزایدات شرکت کرده:</span>
            <span>{participated_auctions}</span>
          </div>
          <div className="flex w-full font-normal text-[16px] justify-between">
            <span>تعداد مزایدات برنده شده:</span>
            <span></span>
          </div>
        </div>
      </div>
      <div className="flex w-full">
        <CustomButton
          disabled={is_saled}
          className="!bg-green-1  "
          type="submit"
          title="برنده شد "
          onClick={() => mutate({guid, delete: isDelete ? isDelete : false})}
        />
        <CustomButton
          className="!bg-inherit  !text-primary"
          type="button"
          title="بازگشت"
          onClick={() => {
            setIsOpenModal(false);
          }}
        />
      </div>
    </div>
  );
};

export default ParticipatedCard;
